import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type EddrState = Readonly<{
  reportDates: Record<string, string[] | null | undefined>;
}>;

export const initialState: EddrState = { reportDates: {} };

const eddrSlice = createSlice({
  name: 'Eddr',
  initialState,
  reducers: {
    updateEddr: (state, action: PayloadAction<{ tuwi: string; dates: string[] }>) => {
      state.reportDates[action.payload.tuwi] = action.payload.dates;
    },
  },
});

export const { updateEddr } = eddrSlice.actions;
export default eddrSlice.reducer;
